<template>
  <div class="relative">
    <div class="vx-navbar-wrapper custom-navbar-wrapper navbar-full p-0">
      <vs-navbar class="navbar-custom navbar-skelton" :class="navbarClasses" :style="navbarStyle" :color="navbarColor">

        <profile-drop-down  v-if="isMobile"/>


        <vs-spacer v-if="isMobile" />

        <!--<bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->
        <span v-if="!isMobile" class="date md:text-md text-md text-primary cursor-pointer text-center">{{ getDate }}  {{ hourTime }}</span>


        <custom-datepicker element-id="selectDate"
                           :format="$u.locale.validator('moment.date')" />


        <!--<div class="vx-logo cursor-pointer w-5/12 md:w-1/4 mx-auto flex items-center">
          &lt;!&ndash;<logo class="w-10 mr-4 fill-current text-primary" />
          <span class="vx-logo-text text-primary">Vuexy</span>&ndash;&gt;
          <custom-select class="text-center" :options="[{label: 'فروشگاه تنیس آریا', value: 1},{label: 'فروشگاه تنیس آریا2', value: 2},]"/>
        </div>-->
        <vs-spacer/>

<!--        <i18n class="mr-5"/>-->

<!--        <notification-drop-down :class="{'mr-5': !isMobile}"/>-->


<!--        <search-bar class="mr-4" />-->

        <profile-drop-down v-if="!isMobile"/>

      </vs-navbar>
    </div>
  </div>
</template>

<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import ProfileDropDown from './components/ProfileDropDown.vue'
import {mapGetters} from 'vuex'
import CustomDatepicker from '@/components/datepicker/customDatepicker.vue'
import CustomDrawer from '@/components/drawer/customDrawer.vue'

const moment = require('moment-jalaali')

export default {
  name: 'theMainNavbar',
  data () {
    return {
      route: this.$route,
      actions: this.navbarActions,
      showFinancialYearPromptStatus: false,
      getCurrentHourTimer: 0,
      hourTime: '',
      financialYear: {
        startYear: '',
        endYear: ''
      }
    }
  },
  props: {
    logo: {type: String},
    navbarType: {
      type: String,
      default: 'floating'
    }
  },
  components: {
    CustomDrawer,
    CustomDatepicker,
    // NotificationDropDown: () => import('./components/NotificationDropDown.vue'),
    ProfileDropDown,
    datePicker: VuePersianDatetimePicker
  },
  computed: {
    getDate () {
      moment()
      const format = this.$u.locale.validator('moment.dateWithWeek')
      return moment(this.$u.time()).locale(this.$i18n.locale).format(format)
    },
    navbarColor () {
      let color = '#fff'
      if (this.navbarType === 'sticky') color = '#f7f7f7'
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#f7f7f7'
        }
      }

      if (this.isThemedark === 'dark') {
        if (color === '#fff') {
          color = '#131314'
        } else {
          color = '#131314'
        }
      }

      return color
    },
    isThemedark () {
      return this.$store.state.theme
    },
    navbarStyle () {
      return this.navbarType === 'static' ? {transition: 'all .25s ease-in-out'} : {}
    },
    navbarClasses () {
      return this.scrollY > 5 && this.navbarType === 'static' ? null : 'd-theme-dark-light-bg shadow-none'
    },
    scrollY () {
      return this.$store.state.scrollY
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    isMobile () {
      return this.$store.state.windowWidth < this.$store.state.mobileScreen
    },

    ...mapGetters(['navbarActions'])
  },

  created () {
    this.getFinancialYearInfo()
    this.getTime()
  },

  methods: {
    getTime () {
      const format = this.$u.locale.validator('moment.time')
      const serverTime = this.$u.time()
      let minutesCount = 0
      this.hourTime = moment(serverTime).locale(this.$i18n.locale).format(format)
      setTimeout(() => {
        minutesCount++
        this.hourTime = moment(serverTime).add(minutesCount, 'm').format(format)
        this.getCurrentHourTimer = setInterval(() => {
          minutesCount++
          this.hourTime = moment(serverTime).add(minutesCount, 'm').format(format)
        }, 60000)
      }, 60000 - (parseInt(moment(serverTime).format(this.$u.locale.validator('moment.second'))) * 1000))
    },
    eventHandler (value, type) {
      switch (type) {
      case 'link':
        this.$router.push(value)
        break

      default:
        document.getElementById(`${value}`).click()
        break
      }
    },
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    },

    getFinancialYearInfo () {
      this.financialYear = this.$store.state.auth.user.financial_year
      if (this.financialYear) {
        this.financialYear.startYear = this.financialYear.started_at.split('/')[0]
        this.financialYear.endYear = this.financialYear.finished_at.split('/')[0]
      } else {
        this.financialYear = {
          startYear: '',
          endYear: ''
        }
      }
    },

    handleShowFinancialYearClicked () {
      if (this.$u.checkPermissions('financial_year.switch')) {
        this.showFinancialYearPromptStatus = true
      }
    }
  },
  watch: {
    '$route' () {
      this.$store.dispatch('updateNavbarActions', [])
      this.route = this.$route
    },
    '$store.state.navbarActions': {
      handler (val) {
        this.actions = val
      },
      deep: true
    },
    '$store.state.auth.user.financial_year': {
      handler () {
        this.getFinancialYearInfo()
      },
      deep: true
    }
  },
  beforeDestroy () {
    clearInterval(this.getCurrentHourTimer)
  }
}

</script>

<style lang="scss">
.vx-navbar-wrapper {

  &.custom-navbar-wrapper {
    height: fit-content;
    background: transparent !important;
    box-shadow: none !important;

    .vpd-actions {
      display: none;
    }
  }

  .financial-year-label {
    border: 1px solid #cdcdcd;
    margin: 0 5px;
    padding: 5px 10px;
    color: #48b4e0;
    border-radius: 0.5rem;

    &:hover {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.01);
    }
  }

  .date {
    /*margin: 0 15px;*/
  }

  .useral-custom-element-select {

    .selected {
      background-color: #131314;
      border-radius: 0;
      cursor: pointer;
      border-bottom: 1px solid #333333;
    }

    .open {
      border-bottom: 0;
    }

    .items {
      border-radius: 0px 0px 3px 3px;
      box-shadow: 0px 5px 10px black;
      background-color: #131314;

      div:hover {
        background-color: #222222;
      }
    }
  }
}
</style>

